import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export const Shell = ({ children, accent = "ink", title, subtitle, testid }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const bar =
    accent === "logo" ? "border-logo" : accent === "centro" ? "border-centro" : "border-ink-700";

  return (
    <div className="flex min-h-screen flex-col bg-beige font-body text-ink-900">
      <header className="sticky top-0 z-30 border-b border-border bg-white/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-4 sm:px-6">
          <Link to="/" data-testid="logo-home-link" className="font-head text-2xl font-semibold tracking-tight">
            SISU
          </Link>
          <div className="flex items-center gap-3">
            {user ? (
              <>
                <Button
                  data-testid="header-profile-btn"
                  variant="outline"
                  className="h-12 text-base"
                  onClick={() => navigate(user.role === "admin" ? "/admin" : "/perfil")}
                >
                  {user.role === "admin" ? "Panel del equipo" : "Mi cuenta"}
                </Button>
                <Button
                  data-testid="header-logout-btn"
                  variant="ghost"
                  className="h-12 text-base"
                  onClick={async () => {
                    await logout();
                    navigate("/");
                  }}
                >
                  Cerrar sesión
                </Button>
              </>
            ) : (
              <Button
                data-testid="header-login-btn"
                variant="outline"
                className="h-12 text-base"
                onClick={() => navigate("/entrar")}
              >
                Acceder a mi cuenta
              </Button>
            )}
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-10 sm:px-6 lg:px-8" data-testid={testid}>
        {title && (
          <div className={`mb-8 border-l-4 pl-5 ${bar}`}>
            <h1 className="font-head text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h1>
            {subtitle && <p className="mt-2 max-w-3xl text-lg text-ink-700">{subtitle}</p>}
          </div>
        )}
        <div className="fade-in">{children}</div>
      </main>

      <footer className="mt-16 border-t border-border bg-cream">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-8 text-base text-ink-700 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <span>SISU · Centro de Estudios y Logopedia (Xaló y Dénia)</span>
          <div className="flex flex-wrap gap-5">
            <Link data-testid="footer-privacy-link" className="underline" to="/privacidad">
              Política de Privacidad
            </Link>
            <Link data-testid="footer-legal-link" className="underline" to="/aviso-legal">
              Aviso Legal
            </Link>
            <Link data-testid="footer-policy-link" className="underline" to="/centro/politica">
              Política del centro de estudios
            </Link>
            <Link data-testid="footer-calendar-link" className="underline" to="/calendario">
              Días de cierre
            </Link>
            <Link data-testid="footer-team-link" className="underline" to="/equipo">
              Acceso del equipo
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export const Card = ({ children, className = "", ...rest }) => (
  <div
    className={`min-w-0 overflow-x-auto rounded-2xl border border-border bg-white p-6 shadow-sm sm:p-8 ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export const Steps = ({ step, total, label }) => (
  <div className="mb-8">
    <p className="mb-2 text-base font-medium text-ink-700">
      Paso {step} de {total} · {label}
    </p>
    <div className="h-3 w-full overflow-hidden rounded-full bg-white">
      <div
        className="h-3 rounded-full bg-centro transition-[width] duration-300"
        style={{ width: `${(step / total) * 100}%` }}
      />
    </div>
  </div>
);
